const getEquipmentsQRCodes = {
  toastr: 'Equipamento adicionado',
  toastr1: 'O equipamento foi adicionado com sucesso',
  toastrError: 'Equipamento já cadastrado',
  toastrError1: 'Insira este CNPJ ou Nome já foi cadastrado'
};

export default getEquipmentsQRCodes;
